import React from 'react'
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'

const SUPPORTED_LANGUAGES = ['en', 'ar', 'fa']

/**
 * Ensures /:lang is only matched for real language codes.
 * Without this, /events/my-slug is treated as lang=events and renders a blank page.
 */
const ValidLanguageGuard = () => {
  const { lang } = useParams()
  const location = useLocation()

  if (!SUPPORTED_LANGUAGES.includes(lang)) {
    return <Navigate to={`/en${location.pathname}${location.search}${location.hash}`} replace />
  }

  return <Outlet />
}

export default ValidLanguageGuard
